import React, { Component } from 'react';
import {routerShape} from 'react-router';

class Logout extends Component {
  static propTypes = {
    router: routerShape.isRequired
  };

  componentWillUnmount() {
    const { _timer } = this;

    if (_timer) {
      clearTimeout(_timer);
    }
  }

  componentDidMount() {
    const { router } = this.props;
    const timer = setTimeout(() => {
      router.push('/account/login');
    }, 5000);

    this._timer = timer;
  }

  render() {
    return <div className='flex-element text-sm-center'>
      You have been successfully logged out.
    </div>;
  }
}

export default Logout;



// WEBPACK FOOTER //
// ./src/apps/Account/components/Logout.js